'use strict';


var providers = {};


module.exports = {
    onAppInit: function ( pluginConfig, callback ) {
        var collector = require('./modules/collector'),
            api = require('../../index'),
            sharedObjects = require('./modules/shared.objects');

        collector.imagePath = pluginConfig.path + 'img/' + screen.height + '/';

        collector.destroy = function () {
            // needs to clearify in launcher for develop mode
            providers = {};
            collector.rows = [];
            collector.providers = [];
        };

        sharedObjects.config = pluginConfig;

        require('mag-gettext').load({
            name: window.core.environment.language
        }, function () {
            var gettext = require('mag-gettext').gettext;

            console.log('MAJOR_VERSION is ' + JSON.stringify(MAJOR_VERSION));

            collector.providers.push({
                application: {
                    name: gettext('Apps'),
                    colors: {
                        splashFont: '#fff',
                        splashBackground: '#efbe01'
                    },
                    uris: {
                        icons: {
                            primeLogoActive: collector.imagePath   + 'apps.icon.focus.png',
                            primeLogoNormal: collector.imagePath   + 'apps.icon.png',
                            shadowNormal: collector.imagePath + 'apps.shadow.png',
                            shadowActive: collector.imagePath + 'apps.shadow.focus.png'
                        }
                    }
                },
                layout: 'apps'
            });
            collector.rows.push([]);

            // filling the list of applications
            // filling the list of content providers
            window.core.packages.forEach(function ( pkg ) {
                var layout = false,
                    // addRow = null,
                    providerConfig;//, rowIndex;

                if ( pkg.type === 'app' ) {
                    // add to application list
                    console.log('add to applications ' + pkg.name);

                    console.log(pkg.packageName);
                    collector.rows[0].push({
                        layout: api.layouts.application,
                        geometry: api.geometry.horizontal,
                        data: {
                            name: pkg.name,
                            description: pkg.description,
                            colors: pkg.colors,
                            icons: pkg.uris.icons,
                            onClick: function () {
                                require('./utils/run.app')(pkg);
                            }
                        }
                    });

                    // resolve content providers
                    if ( pkg.contentProviders && pkg.contentProviders.length > 0 ) {
                        console.log('check for providers in applications ' + pkg.name);
                        // create
                        if ( typeof pkg.contentProviders === 'string' ) {
                            console.log('pkg.contentProviders: ' + pkg.contentProviders);
                            providerConfig = window.core.packageMap[pkg.contentProviders];
                            if ( typeof providerConfig === 'undefined' ) {
                                return;
                            }

                            console.log(pkg.contentProviders);
                            console.log('contentBoardAPI ' + JSON.stringify(providerConfig.contentBoardApi));
                            console.log('MAJOR_VERSION ' + JSON.stringify(MAJOR_VERSION));
                            if ( providerConfig.contentBoardApi === MAJOR_VERSION ) {
                                // more then one application
                                if ( providers[providerConfig.packageName] ) {
                                    console.log('pkg ' + providerConfig.packageName);
                                    providers[providerConfig.packageName].applications.push(pkg);

                                    return;
                                }
                                // console.log('PUSH TO PROVIDERS');
                                // console.log(providerConfig.packageName);

                                if ( pkg.resource ) {
                                    layout = pkg.resource;
                                }
                                console.log('layout: ' + layout);

                                providers[providerConfig.packageName] = {
                                    colors: pkg.colors,
                                    instance: null,
                                    packageName: providerConfig.packageName,
                                    version: providerConfig.version,
                                    application: pkg,
                                    applications: [pkg],
                                    layout: layout,
                                    onClick: function () {
                                        require('./utils/run.app')(pkg);
                                    }
                                };
                                collector.providers.push(providers[providerConfig.packageName]);
                            }
                        } else {
                            console.log('providers is array');
                            pkg.contentProviders.forEach(function ( provider ) {
                                console.log('pkg.contentProviders: ' + provider);
                                providerConfig = window.core.packageMap[provider];
                                if ( typeof providerConfig === 'undefined' ) {
                                    return;
                                }

                                // console.log(provider);
                                // console.log('contentBoardAPI ' + JSON.stringify(providerConfig.contentBoardApi));
                                // console.log('MAJOR_VERSION ' + JSON.stringify(MAJOR_VERSION));
                                if ( providerConfig.contentBoardApi === MAJOR_VERSION ) {
                                    if ( providers[providerConfig.packageName] ) {
                                        providers[providerConfig.packageName].applications.push(pkg);

                                        return;
                                    }

                                    // console.log('PUSH to providers');
                                    // console.log(providerConfig.packageName);

                                    if ( pkg.resource ) {
                                        layout = pkg.resource;
                                    }

                                    providers[providerConfig.packageName] = {
                                        colors: pkg.colors,
                                        instance: null,
                                        packageName: provider,
                                        version: providerConfig.version,
                                        application: pkg,
                                        applications: [pkg],
                                        layout: layout,
                                        onClick: function () {
                                            require('./utils/run.app')(pkg);
                                        }
                                    };
                                    collector.providers.push(providers[providerConfig.packageName]);
                                }
                            });
                        }
                    }
                }
            });

            console.log('providers.length at start ' + collector.providers.length);

            try {
                callback(null, collector);
            } catch ( e ) {
                console.log('error in plugin ' + __filename + ':112 ' + e);
            }
        });
    }
};
